<template>
  <div class="drawer-detail">
    <div v-for="field in fields" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <pre class="value company-pre">{{company[field] || '暂无数据'}}</pre>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['特殊要求寻访', '推荐备注', '特殊要求面试安排'],
      translateTag: {
        特殊要求寻访: '特殊要求',
        推荐备注: '推荐要求',
        特殊要求面试安排: '面试安排',
      },
    }
  },
  methods: {},
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
